import { render, staticRenderFns } from "./TwitterCampaign.vue?vue&type=template&id=2b4471cb&scoped=true&"
import script from "./TwitterCampaign.vue?vue&type=script&lang=js&"
export * from "./TwitterCampaign.vue?vue&type=script&lang=js&"
import style0 from "./TwitterCampaign.vue?vue&type=style&index=0&id=2b4471cb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4471cb",
  null
  
)

export default component.exports